import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import jwt_decode from "jwt-decode";
import GooLoader from "../../Components/GooLoader/GooLoader";
import { Helmet } from "react-helmet-async";
import SelectAutocomplete from "../../Components/SelectAutocomplete/SelectAutocomplete";
import ErrorBox from "../../Components/ErrorBox/ErrorBox";
import call from "../../API/API";
import "./OtherCity.css";

class OtherCity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      city: "",
      errorBoxTitle: "",
      errorBoxBody: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.handleAutoCompleteOnChange = this.handleAutoCompleteOnChange.bind(
      this
    );
    this.handleAutoCompleteOnClick = this.handleAutoCompleteOnClick.bind(this);
    this.showErrorBox = this.showErrorBox.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.replace("/");
    } else {
      let decoded = jwt_decode(token);
      if (decoded.active) {
        this.props.history.push("/dashboard");
      } else {
        if (
          this.props.location.state === undefined ||
          !this.props.location.state.userData
        ) {
          this.props.history.push("/hyperlocal-networks");
        } else {
          let userData = this.props.location.state.userData;
          const { otherCity } = userData;
          if (!otherCity) {
            this.props.history.push("/hyperlocal-networks", {
              userData: userData,
            });
          } else {
            this.setState(
              {
                city: "",
                filteredCities: [],
              },
              () => {
                this.setState({
                  isLoading: false,
                });
              }
            );
          }
        }
      }
    }
  }

  handleAutoCompleteOnChange(e) {
    const input = e.target.value;
    if (input === "") {
      this.setState({
        city: input,
        filteredCities: [],
      });
    } else {
      this.setState(
        {
          city: input,
        },
        () => {
          call.cities
            .searchCity(input)
            .then((response) => {
              this.setState({
                filteredCities: response,
              });
            })
            .catch((err) => console.log(err.message));
        }
      );
    }
  }

  handleAutoCompleteOnClick(city, subcountry, country) {
    this.setState({
      city: `${city}, ${subcountry}, ${country}`,
    });
  }

  handleSubmit() {
    const fullCity = this.state.city;
    if (!fullCity) {
      this.showErrorBox("No city selected", "Please select a city");
    } else {
      const separated = fullCity.split(", ");
      const city = separated[0];
      const subcountry = separated[1];
      const country = separated[2];
      console.log(city);
      const token = localStorage.getItem("token");
      const decoded = jwt_decode(token);
      console.log(decoded);
      call.cities
        .verifyCity(city, subcountry, country)
        .then((response) => {
          if (response.cityExists) {
            call.users_API
              .setCity(fullCity)
              .then((res) => {
                if (res.success) {
                  localStorage.clear();
                  this.props.history.push("/create-account");
                } else {
                  this.showErrorBox("error", res.results);
                }
              })
              .catch((err) => {
                this.props.history.push("/error", { error: err.message });
              });
          } else {
            this.showErrorBox(
              "City not available",
              "Please choose your city from suggestions"
            );
          }
        })
        .catch((err) => {
          this.props.history.push("/error", {
            error: "Something wrong happened. Please try again.",
          });
        });
    }
  }

  handleBackButton() {
    this.props.history.goBack();
  }

  showErrorBox(title, message) {
    this.setState(
      {
        errorBoxTitle: title,
        errorBoxBody: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            errorBoxTitle: "",
            errorBoxBody: "",
          });
        }, 3000);
      }
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.props.isLoading ? <GooLoader /> : null}
        <RegistrationForm
          containerClassName="container-other-city"
          hasCounter={false}
          hasQuote={true}
          quote="We'd love to support your city, but right now we're launching in Austin, Texas. Nonetheless, if you let us know where you're located, we'll look for entrepreneurs in your city and will email you once we launch there."
          headerText="Hopefully soon"
          primaryButtonText="Submit"
          hasSkip={false}
          showButton={true}
          showBackButton={true}
          handlePrimaryBtnOnClick={this.handleSubmit}
          activatePrimaryWithEnter={true}
          handleBackButtonClick={this.handleBackButton}
          backButtonText="Back"
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          <section className="form-container-body-row">
            <SelectAutocomplete
              label="Which city are you nearest?"
              value={this.state.city}
              onChange={this.handleAutoCompleteOnChange}
              data={this.state.filteredCities}
              handleOnClick={this.handleAutoCompleteOnClick}
              placeholder="City name"
            />
          </section>
        </RegistrationForm>
        <ErrorBox
          title={this.state.errorBoxTitle}
          body={this.state.errorBoxBody}
        />
      </React.Fragment>
    );
  }
}

export default OtherCity;
